var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"banner-view"},[(_vm.lang==1)?_c('div',[_c('img',{attrs:{"src":_vm.login_zh}})]):_vm._e(),_vm._v(" "),(_vm.lang==2)?_c('div',[_c('img',{attrs:{"src":_vm.login_en}})]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f1c45e4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/base/Banner.vue
// module id = null
// module chunks = 